// extracted by mini-css-extract-plugin
export default {"baseLink":"links_baseLink__J6jWx","switchLink__active":"links_switchLink__active__kPlSp","switchLink":"links_switchLink__Q19CE"};